function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#527fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-DynamoDB_Table_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M11.94,11.94H1.5V1.5H11.94Zm-8.44-2H9.94V3.5H3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M11.94,24.12H1.5V13.69H11.94Zm-8.44-2H9.94V15.69H3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M11.94,36.31H1.5V25.88H11.94Zm-8.44-2H9.94V27.88H3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M11.94,48.5H1.5V38.06H11.94Zm-8.44-2H9.94V40.06H3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M48.5,11.94H13.69V1.5H48.5Zm-32.81-2H46.5V3.5H15.69Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M48.5,24.12H13.69V13.69H48.5Zm-32.81-2H46.5V15.69H15.69Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M48.5,36.31H13.69V25.88H48.5Zm-32.81-2H46.5V27.88H15.69Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M48.5,48.5H13.69V38.06H48.5Zm-32.81-2H46.5V40.06H15.69Z"
}));

var SvgAwsDynamoDbTable = function SvgAwsDynamoDbTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsDynamoDbTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-DynamoDB_Table.0f12b6ae.svg";
export { ForwardRef as ReactComponent };